import type { UIEvent, ReactNode } from 'react';

import { Link } from 'react-router-dom';

export const LinkWrapper = ({
  children,
  onClick,
  href,
  ...props
}: {
  children: ReactNode;
  href: string;
  onClick?: (event: UIEvent) => void;
}) => {
  return (
    <Link onClick={onClick} to={href} {...props}>
      {children}
    </Link>
  );
};
